import APP from '../app/index';

const selectInit = () => {
  const maxHeight = 300;

  $('.js-select').each(function sInit() {
    const $this = $(this);

    if ($this.hasClass('select-inited')) return;
    $this.select2({
      width: $this.data('width') || '100%',
      theme: $this.data('theme') || 'custom-select2',
      minimumResultsForSearch: -1,
      dropdownAutoWidth: true,
    });
    $this.addClass('select-inited');

    $this.on('select2:open', () => {
      // TODO: fix select2 vs nanoscroller height
      setTimeout(() => {
        const $selectOptions = $('.select2-results__options');

        if ($selectOptions.height() <= maxHeight) return;

        $selectOptions
          .addClass('nano-content')
          .parent().addClass('nano')
          .nanoScroller({ alwaysVisible: true });
      }, 0);
    });
  });
};

// generate select from btn-group
//-------------------------------------------------------------------------------
const selectBtnGroupInit = () => {
  const generateSelect = (items) => {
    const selectHtml = ['<div class="select-label"><select class="js-select">'];

    for (let i = 0; i < items.length; i++) {
      selectHtml.push(`<option value="${items[i].link}">${items[i].text}</option>`);
    }
    selectHtml.push('</select>');
    return selectHtml.join('');
  };

  const pasteBtnGroup = (btnsHtml, $container) => {
    $container.html(btnsHtml);
    $container.removeClass('btn-group-select');
  };

  const pasteSelect = ($container, btnArray) => {
    $container.html(generateSelect(btnArray));
    $container.addClass('btn-group-select');
    selectInit();
  };

  $('.js-group-btn-select').each(function sgInit() {
    const $this = $(this);
    const btnHtml = $this.html();
    const $btns = $this.find('.btn');
    const btnArray = [];
    let isBtnHtml = null;

    $btns.each(function btEach() {
      const btnThis = $(this);

      btnArray.push({
        link: btnThis.data('link'),
        text: btnThis.html(),
      });
    });

    if (APP.viewport.isMobile) {
      pasteSelect($this, btnArray);
      isBtnHtml = false;
    } else {
      isBtnHtml = true;
    }

    APP.$window.resize(() => {
      if (APP.viewport.isMobile && isBtnHtml) {
        pasteSelect($this, btnArray);
        isBtnHtml = false;
      }
      if (!APP.viewport.isMobile && !isBtnHtml) {
        pasteBtnGroup(btnHtml, $this);
        isBtnHtml = true;
      }
    });
  });
};

selectInit();
selectBtnGroupInit();


$(window).on('inputUpdate', selectInit);



// WEBPACK FOOTER //
// ./src/scripts/components/select/index.js